import * as React from "react";
import {useSelector} from "react-redux";

import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import {StoreState} from "../../store";
import { LocalCode } from "../../store/i18n/types";
import { LANGUAGES } from "../../Commons/SessionLanguage";
import useSelectLanguage from "../../Commons/SessionLanguage/useSelectLanguage";


const AuthLanguageForm : React.FC = () => {

    let selectLanguage = useSelectLanguage()
    let currentCodeLang = useSelector((state: StoreState) => state.i18n.localCode)

        return(
            <ButtonGroup toggle className={'d-block mt-3'}>
                {LANGUAGES.map((lang, idx) => (
                <ToggleButton
                    key={idx}
                    type="radio"
                    className={'m-2'}
                    name="lang"
                    value={lang.value}
                    checked={currentCodeLang === lang.value}
                    onChange={(e) => selectLanguage(e.currentTarget.value as LocalCode)}
                >
                    {lang.name}

                </ToggleButton>))}
        </ButtonGroup>
    );
}


export default AuthLanguageForm;
